import { fontSizes, colors } from '../../Components/consts'
import { styled } from '@mui/system'

export const HeadCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  '& .weekendHeaderCon': {
    display: 'flex',
    flexDirection: 'column',
    minWidth: '50%',
    [theme.breakpoints.down('sm')]: {
      minWidth: '70%',
    },
    '& h1': {
      fontSize: fontSizes.semiLarge,
      fontWeight: 700,
      color: colors.white,
      marginTop: 5,
      [theme.breakpoints.down('sm')]: {
        fontSize: fontSizes.small,
        marginTop: 8,
      },
    },
    '& p': {
      fontSize: fontSizes.medium,
      color: colors.gray.gray40,
      fontWeight: 700,
      margin: theme.spacing(0),
      [theme.breakpoints.down('sm')]: {
        fontSize: fontSizes.small,
      },
    },
  },
}))

export const HeadActions = styled('button')(({ theme }) => ({
  textAlign: 'center',
  padding: theme.spacing(2, 0),
  margin: theme.spacing(2, 1),
  fontSize: fontSizes.medium,
  minWidth: 230,
  fontWeight: 700,
  color: colors.white,
  borderRadius: 15,
  border: 'none',
  background: colors.lightBlue,
  cursor: 'pointer',
  [theme.breakpoints.down('sm')]: {
    fontSize: fontSizes.small,
    minWidth: 100,
    padding: theme.spacing(1),
    margin: theme.spacing(1),
  },
  '&:hover': {
    color: colors.black,
    backgroundColor: colors.yellow,
    border: `1px solid ${colors.yellow}`,
  },
  '&:focus': {
    outline: 'none',
  },
}))

export const MatchActions = styled('button')(({ theme }) => ({
  textAlign: 'center',
  padding: theme.spacing(2, 1),
  margin: theme.spacing(2, 1),
  fontSize: fontSizes.medium,
  width: '40vw',
  fontWeight: 700,
  color: colors.white,
  border: `1px solid ${colors.lightBlue}`,
  borderRadius: 15,
  background: colors.lightBlue,
  cursor: 'pointer',
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.8rem',
    padding: theme.spacing(1, 0.25),
    margin: theme.spacing(1),
  },
  '&:hover': {
    color: colors.gray.gray20,
    backgroundColor: colors.yellow,
    border: `1px solid ${colors.yellow}`,
  },
  '&:focus': {
    outline: 'none',
  },
}))
export const TeamInfo = styled('div')(({ theme }) => ({
  display: 'block',
  textAlign: 'left',
  margin: theme.spacing(0, 1),
  background: 'none',
  '& h2': {
    fontWeight: 700,
    fontSize: fontSizes.semiLarge,
    color: colors.white,
    margin: 0,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.7rem',
    },
  },
  '& p': {
    fontWeight: 500,
    fontSize: fontSizes.medium,
    color: colors.gray.gray20,
    marginTop: 5,
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.small,
      marginTop: 0,
    },
  },
  '& img': {
    height: 70,
    margin: theme.spacing(0, 1, 1, 0),
    [theme.breakpoints.down('sm')]: {
      height: 40,
    },
  },
}))

export const HubTitle = styled('h2')(({ theme }) => ({
  marginTop: theme.spacing(1),
  color: colors.white,
  [theme.breakpoints.down('sm')]: {
    fontSize: fontSizes.medium,
  },
}))

export const MatchupCon = styled('div')(({ theme }) => ({
  display: 'block',
  textAlign: 'left',
  margin: theme.spacing(0, 0),
  backgroundColor: colors.darkBackground,
  '& h2': {
    fontWeight: 700,
    fontSize: fontSizes.semiLarge,
    color: colors.white,
    margin: 0,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.7rem',
    },
  },
  '& p': {
    fontWeight: 500,
    fontSize: fontSizes.medium,
    color: colors.gray.gray20,
    marginTop: 5,
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.small,
      marginTop: 0,
    },
  },
  '& img': {
    height: 70,
    margin: theme.spacing(0, 1, 1, 0),
    [theme.breakpoints.down('sm')]: {
      height: 40,
    },
  },
}))

export const DateCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  '& h2': {
    fontWeight: 700,
    fontSize: fontSizes.semiLarge,
    color: colors.white,
    margin: 0,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.7rem',
    },
  },
  '& p': {
    fontWeight: 500,
    fontSize: fontSizes.medium,
    color: colors.gray.gray20,
    marginTop: 5,
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.small,
      marginTop: 0,
    },
  },
}))
